import { useState } from 'react';

function IntroductionToOptionsTradingModule() {
  const [openModule, setOpenModule] = useState(null);

  const toggleModule = (index) => {
    setOpenModule(openModule === index ? null : index);
  };

  const modules = [
    {
      title: "Module 1: What Are Options?",
      content: [
        "Definition of options and their role in financial markets.",
        "Difference between stocks and options.",
        "Overview of call and put options.",
        "Key terminologies: Strike price, expiration date, premium, and contract size."
      ]
    },
    {
      title: "Module 2: Types of Options",
      content: [
        "Call Options: What they are and when to buy them.",
        "Put Options: What they are and when to buy them.",
        "Examples of how call and put options work in different scenarios."
      ]
    },
    {
      title: "Module 3: Options vs. Futures",
      content: [
        "Fundamental differences between options and futures contracts.",
        "Risk and reward comparison.",
        "Use cases for options vs. futures in trading strategies."
      ]
    },
    {
      title: "Module 4: Options Pricing Fundamentals",
      content: [
        "Understanding how options are priced.",
        "Introduction to the Black-Scholes model.",
        "The concept of intrinsic value and time value.",
        "Factors affecting options pricing: Underlying asset price, volatility, time decay (Theta), and interest rates."
      ]
    },
    {
      title: "Module 5: The Greeks: Measuring Risk",
      content: [
        "Explanation of Delta, Gamma, Theta, Vega, and Rho.",
        "How the Greeks impact your options strategy.",
        "Practical examples of using the Greeks to manage risk."
      ]
    },
    {
      title: "Module 6: Basic Options Strategies",
      content: [
        "Covered Call: Enhancing returns on your stock holdings.",
        "Protective Put: Insuring your portfolio against losses.",
        "Long Call: Capturing upside potential with limited risk.",
        "Long Put: Profiting from market downturns."
      ]
    },
    {
      title: "Module 7: Advanced Options Strategies",
      content: [
        "Straddle and Strangle: Trading volatility.",
        "Bull Call Spread & Bear Put Spread: Directional strategies with limited risk.",
        "Iron Condor & Butterfly Spread: Range-bound strategies for low-volatility markets."
      ]
    },
    {
      title: "Module 8: Options Expiry and Settlement",
      content: [
        "Understanding the options expiry process.",
        "In-the-money (ITM) vs. out-of-the-money (OTM) options.",
        "Cash-settled vs. physical delivery.",
        "What happens when you hold an option until expiry?"
      ]
    },
    {
      title: "Module 9: Risk Management in Options Trading",
      content: [
        "Importance of position sizing and stop-loss orders.",
        "Managing leverage and margin requirements.",
        "Diversifying your options portfolio to reduce risk.",
        "Psychological aspects of trading: Dealing with emotions."
      ]
    },
    {
      title: "Module 10: Using Options for Hedging",
      content: [
        "Protecting your stock portfolio from downside risk.",
        "How businesses use options to hedge against market volatility.",
        "Real-life examples of hedging with options."
      ]
    },
    {
      title: "Module 11: Trading Platforms and Tools",
      content: [
        "Overview of popular trading platforms for options (e.g., Zerodha, Upstox, Interactive Brokers).",
        "Understanding option chain and option analyzer tools.",
        "Setting up paper trading accounts for practice.",
        "Tips for selecting the right broker and platform for your needs."
      ]
    }
  ];

  return (
    <div className="container-fluid">
      <div className="container">
        <h1 className="text-center py-5">Introduction to Options Trading Course Curriculum</h1>
        <div className="row justify-content-center">
          {modules.map((module, index) => (
            <div
              key={index}
              className="col-12 col-md-5 mb-3 d-flex flex-column align-items-center"
              style={{ marginBottom: '10px' }}
            >
              {/* Accordion Heading */}
              <div
                className="w-100 p-3 d-flex justify-content-between align-items-center"
                style={{
                  backgroundColor: '#f8f9fa',
                  border: '1px solid #ddd',
                  cursor: 'pointer'
                }}
                onClick={() => toggleModule(index)}
              >
                <h5 className="m-0">{module.title}</h5>
                <span
                  style={{
                    fontSize: '18px',
                    transform: openModule === index ? 'rotate(180deg)' : 'rotate(0deg)',
                    transition: 'transform 0.3s'
                  }}
                >
                  ▼
                </span>
              </div>

              {/* Accordion Content */}
              {openModule === index && (
                <div
                  className="w-100 p-3"
                  style={{
                    border: '1px solid #ddd',
                    borderTop: 'none',
                    backgroundColor: '#ffffff'
                  }}
                >
                  {module.content.map((item, itemIndex) => (
                    <div
                      key={itemIndex}
                      className="d-flex align-items-center mb-2"
                      style={{
                        border: '1px solid #ddd',
                        borderRadius: '4px',
                        padding: '8px',
                        backgroundColor: '#fdfdfd'
                      }}
                    >
                      <span style={{ color: '#007bff', marginRight: '8px' }}>➤</span>
                      <p className="m-0" style={{ fontSize: '14px', color: '#333' }}>
                        {item}
                      </p>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default IntroductionToOptionsTradingModule;
